export type { AuthorizationConfig } from './lib/authorization-config';
export { IfAuthorized } from './lib/if-authorized';
export { userRolesMatchAnyRequiredUserRoles as userRolesMatchRequiredUserRoles } from './lib/resource-authorization';
export type { ResourceAuthorization } from './lib/resource-authorization';

